<template>
  <div>
    <z-header white />
    <div class="page_center">
      <div class="bread">
        <router-link to="/">首页></router-link>
        <router-link to="/skill">商学院></router-link>
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="page_center page_content">
      <div class="left_content">
        <div v-if="title" class="page_title">{{ title }}</div>
        <div>
          <router-link
            v-for="(item, index) of newsList"
            :key="index"
            class="news_list"
            :to="'/newsDetails/' + item.objId"
          >
            <div class="image">
              <img :src="item.headImg" :alt="item.title" />
            </div>
            <div class="news_info">
              <div>
                <div class="title">{{ item.title }}</div>
                <div class="description">
                  {{ item.introduce }}
                  <span>阅读全文</span>
                </div>
              </div>
              <div class="label">
                <span
                  v-for="(childItem, childIndex) of item.label"
                  :key="childIndex"
                  >{{ childItem }}</span
                >
              </div>
            </div>
          </router-link>
        </div>
        <z-page :current-page="pageNo" :total="pages" @change="getNewsList" />
      </div>
      <div class="right_content">
        <div class="content_title">开发服务类型</div>
        <div class="service_type_box">
          <router-link
            v-for="(item, index) in serviceTypeList"
            :key="index"
            :to="'/newsList/' + item.objId + '?name=' + item.name"
            >{{ item.name }}
          </router-link>
        </div>
        <div class="content_title">APP商学院推荐阅读</div>
        <div class="recommend_list_box">
          <router-link
            v-for="(item, index) of operationSkillList"
            :key="index"
            class="recommend_list"
            :to="'/newsDetails/' + item.objId"
          >
            <div class="image">
              <img :src="item.headImg" :alt="item.title" />
            </div>
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="description">{{ item.introduce }}</div>
            </div>
          </router-link>
        </div>
        <div class="content_title">热门标签</div>
        <div class="service_type_box">
          <router-link
            v-for="(item, index) in popularList"
            :key="index"
            :to="'/newsList/' + item.objId + '?name=' + item.name"
            >{{ item.name }}
          </router-link>
        </div>
      </div>
    </div>
    <z-footer />
  </div>
</template>

<script>
import zPage from "@/components/common/page.vue";
export default {
  components: {
    zPage,
  },
  data() {
    return {
      recommendList: [],
      pageNo: 1,
      total: 1,
      pages: 1,
      classifyList: [
        {
          name: "全部",
          objId: 0,
        },
      ],
      classifyIndex: 0,
      newsList: [],
      serviceTypeList: [],
      popularList: [],
      operationSkillList: [],
      title: "",
      labelTypeId: "",
    };
  },
  created() {
    let objId = this.$route.params.id;
    if (this.$route.query && this.$route.query.name) {
      this.title = this.$route.query.name;
    }
    this.labelTypeId = objId;
    this.getArticleList(3, 3008);
    this.getArticleClassify();
    this.getArticleList();
    this.getBaseTypeClassify();
    this.getArticleList(3, 3005);
  },
  methods: {
    onPageJump(url) {
      this.$router.push(url);
    },
    onClassify(index) {
      this.classifyIndex = index;
      this.pageNo = 1;
      this.getNewsList();
    },
    getNewsList(size) {
      if (size) {
        this.pageNo = size;
      }
      // eslint-disable-next-line prefer-const
      let httpData = {
        pageNo: this.pageNo,
        pageSize: 10,
      };
      if (this.labelTypeId) {
        httpData.labelTypeId = this.labelTypeId;
      }
      if (this.classifyIndex >= 0) {
        httpData.classifyId = this.classifyList[this.classifyIndex].objId;
      }
      this.$axios.post("article/v1/list", httpData).then((res) => {
        this.total = res.count;
        this.newsList = res.data;
        this.pages = res.pages;
      });
    },
    onJumpNewsDetails(objId) {
      let url = window.location.protocol + "//" + window.location.host;
      url += "/newsDetails/" + objId + ".html";
      window.open(url);
    },
    onJumpNewsList(item) {
      // let url = window.location.protocol + "//" + window.location.host;
      // url += "/newsList/" + item.objId + "?name=" + item.name;
      // window.open(url);
      this.$router.replace("/newsList/" + item.objId + "?name=" + item.name);
      if (item.name) {
        this.title = item.name;
      }
      this.labelTypeId = item.objId;
      this.getArticleList(3, 3008);
      this.getArticleClassify();
      this.getArticleList();
      this.getBaseTypeClassify();
      this.getArticleList(3, 3005);
    },

    //获取资讯列表
    getArticleList(pageSize = 10, type) {
      var httpData = {
        pageNo: this.pageNo,
        pageSize: pageSize,
      };
      if (type) {
        httpData.type = type;
      }
      if (this.labelTypeId) {
        httpData.labelTypeId = this.labelTypeId;
      }
      if (this.classifyIndex >= 0) {
        httpData.classifyId = this.classifyList[this.classifyIndex].objId;
      }
      this.$http.post("api/article/v1/list", httpData).then((res) => {
        let Data = res.data;
        if (type == 3008) {
          this.recommendList = Data.data;
          return;
        }
        if (type == 3005) {
          this.operationSkillList = Data.data;
          return;
        }
        this.newsList = Data.data;
        this.pages = Data.pages;
        this.total = Data.count;
      });
    },

    //获取资讯分类列表
    getArticleClassify() {
      const defaultList = [
        {
          name: "全部",
          objId: 0,
        },
      ];
      this.$http.get("api/article/v1/classify").then((res) => {
        this.classifyList = defaultList.concat(res.data);
      });
    },

    //获取标签分类
    getBaseTypeClassify() {
      this.$http.get("api/base_type/classify").then((res) => {
        let Data = res.data;
        this.serviceTypeList = Data.articleLabelPlatform;
        this.popularList = Data.articleLabelHot;
      });
    },
  },

  beforeRouteUpdate(to, from, next) {
    if (to.name == from.name) {
      let objId = to.params.id;
      if (to.query && to.query.name) {
        this.title = to.query.name;
        console.log(this.title);
      }

      this.labelTypeId = objId;
      this.getArticleList(3, 3008);
      this.getArticleClassify();
      this.getArticleList();
      this.getBaseTypeClassify();
      this.getArticleList(3, 3005);
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.bread {
  margin-top: 30px;
  a {
    font-size: 14px;
    color: #333333;
    &:hover {
      color: #527fff;
    }
  }
  span {
    font-size: 14px;
    color: #333333;
  }
}

.page_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 24px;
  color: #333;
  font-weight: 700;
  padding-bottom: 30px;
  border-bottom: 1px solid #e5e5e5;

  &::after {
    content: "";
    margin-top: 30px;
    width: 36px;
    height: 4px;
    background-color: #527fff;
  }
}

.page_content {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 349px);
  margin-top: 30px;
  .left_content {
    width: 790px;
    .page_title {
      font-size: 24px;
      color: #333333;
      font-weight: bold;
      padding-bottom: 30px;
      border-bottom: 1px solid #e5e5e5;
    }
    .news_list {
      padding: 30px 0;
      display: flex;
      border-top: 1px solid #e5e5e5;
      cursor: pointer;
      &:first-child {
        border-top: 0;
      }
      .image {
        width: 290px;
        height: 177px;
        flex-shrink: 0;
        margin-right: 24px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .news_info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          font-size: 18px;
          color: #333333;
          font-weight: bold;
        }
        .description {
          margin-top: 20px;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          span {
            color: #527fff;
          }
        }
        .label {
          display: flex;
          flex-wrap: wrap;
          span {
            min-width: 90px;
            height: 30px;
            border: solid 1px #e5e5e5;
            padding: 0 20px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            color: #333333;
            margin-right: 12px;
          }
        }
      }
    }
  }
  .right_content {
    width: 290px;
    .content_title {
      display: flex;
      flex-direction: column;
      font-size: 18px;
      color: #333333;
      font-weight: bold;
      padding-top: 16px;
    }
    .service_type_box {
      margin-top: 23px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 28px;
      span,
      a {
        width: 140px;
        height: 40px;
        background-color: #f7f7f7;
        border: solid 1px #e5e5e5;
        font-size: 14px;
        color: #333333;
        text-align: center;
        line-height: 40px;
        margin-bottom: 12px;
        cursor: pointer;
        &:hover {
          color: #527fff;
        }
      }
    }
    .recommend_list_box {
      margin-top: 23px;
      margin-bottom: 40px;
      .recommend_list {
        display: flex;
        margin-bottom: 24px;
        cursor: pointer;
        .image {
          width: 130px;
          height: 80px;
          flex-shrink: 0;
          margin-right: 12px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          width: 143px;
          .title {
            font-size: 16px;
            color: #333333;
            @include toe();
            &:hover {
              color: #527fff;
            }
          }
          .description {
            font-size: 14px;
            color: #999999;
            margin-top: 11px;
            @include bov(2);
          }
        }
      }
    }
  }
}
</style>